import firebase from 'firebase/app';
import { firebase as firebaseConfig } from '../config';

import 'firebase/auth';
import 'firebase/database';
import 'firebase/functions'

export const firebaseApp = firebase.initializeApp(firebaseConfig);
export const firebaseAuth = firebaseApp.auth();
export const firebaseDb = firebaseApp.database();
export const firebaseFn = firebaseApp.functions();
